export const geojsonIndex =  [
    {
        value: 0,
        label: '1920',
        maebashi:"./data/maebashi/1920.geojson",
        takasaki: "./data/takasaki/1920.geojson",
        minLatLng: [139.11316, 36.31095],
        maxLatLng: [138.98082, 36.41632 ],
    },
    {
        value: 1,
        label: '1955',
        maebashi: "./data/maebashi/1955.geojson",
        takasaki: "./data/takasaki/1955.geojson",
        minLatLng: [139.17185, 36.28653 ],
        maxLatLng: [138.91520, 36.48340]
    },
    {
        value: 2,
        label: '1960',
        maebashi: "./data/maebashi/1960.geojson",
        takasaki: "./data/takasaki/1960.geojson",
        minLatLng: [139.17185, 36.25299],
        maxLatLng: [138.91520, 36.48340]
    },
    {
        value: 3,
        label: '1965',
        maebashi: "./data/maebashi/1960.geojson",
        takasaki: "./data/takasaki/1965.geojson",
        minLatLng: [139.17185, 36.25299],
        maxLatLng: [138.91520, 36.48340]
    },
    {
        value: 4,
        label: '1970',
        maebashi: "./data/maebashi/1970.geojson",
        takasaki: "./data/takasaki/1965.geojson",
        minLatLng: [139.17185, 36.25299],
        maxLatLng: [138.91520, 36.48340]
    },
    {
        value: 5,
        label: '2005',
        maebashi: "./data/maebashi/2005.geojson",
        takasaki: "./data/takasaki/1965.geojson",
        minLatLng: [139.25352, 36.25299 ],
        maxLatLng: [138.87582, 36.52277]
    },
    {
        value: 6,
        label: '2006',
        maebashi: "./data/maebashi/2005.geojson",
        takasaki: "./data/takasaki/2006.geojson",
        minLatLng: [139.25425, 36.24715],
        maxLatLng: [138.62791, 36.54173]
    },
    {
        value: 7,
        label: '2010',
        maebashi: "./data/maebashi/2010.geojson",
        takasaki: "./data/takasaki/2010.geojson",
        minLatLng: [139.31185, 36.19091],
        maxLatLng: [138.61479,36.57746]
    },
    {
        value: 8,
        label: '2023',
        maebashi: "./data/maebashi/2023.geojson",
        takasaki: "./data/takasaki/2023.geojson",
        minLatLng: [139.31185, 36.19091],
        maxLatLng: [138.61479, 36.57746]
    },
];